import { Button, Dialog, Divider, Flex, Text } from '@applyboard/crystal-ui';
import { ArrowRightOutlineIcon } from '@applyboard/ui-icons';
import { useEventTracker } from '@applyboard/ui-utils';
import { EmailSentIcon } from "./EmailSentIcon";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export function SignUpEmailConfirmation(_ref) {
  var rpEmailId = _ref.rpEmailId,
    handleCreateProfileClick = _ref.handleCreateProfileClick,
    isAutologinInProgress = _ref.isAutologinInProgress;
  var _useEventTracker = useEventTracker(),
    trackEvent = _useEventTracker.trackEvent;
  return _jsxs(Dialog, {
    open: true,
    size: "lg",
    onOpenChange: function onOpenChange() {},
    children: [_jsx(Dialog.Heading, {
      children: "Registration email sent!"
    }), _jsxs(Dialog.Content, {
      children: [_jsxs(Flex, {
        direction: "column",
        gap: 6,
        align: "start",
        children: [_jsx(Flex.Item, {
          align: "center",
          children: _jsx(EmailSentIcon, {})
        }), _jsxs(Text, {
          children: ["Thank you for starting the registration! We sent you an email confirmation to ", " ", rpEmailId, "."]
        }), _jsx(Text, {
          children: "There are three steps in the process, which should take approximately 15 minutes to complete. Once submitted, we will review your request, and get back to you by email within 48 hours."
        }), _jsx(Text, {
          children: "In the meantime, if you weren\u2019t able to finish the process in one attempt, you can come back and resume by clicking the link in the email we sent you. The system wil automatically take you where you left off. To login, simply use the email address and password you created during the registration process."
        }), _jsx(Text, {
          children: "Please note you will not have full access to the platform until your request is approved. If you have any questions, please reach out to us at recruitersupport@applyboard.com."
        })]
      }), _jsx(Divider, {}), _jsx(Dialog.Actions, {
        children: _jsx(Button, {
          onClick: function onClick() {
            handleCreateProfileClick();
            trackEvent({
              group: 'Account Creation',
              event: 'Account Creation - Confirmation Message - Clicked Create Profile'
            });
          },
          width: "fill",
          intent: "primary",
          trailIcon: ArrowRightOutlineIcon,
          loading: isAutologinInProgress,
          children: "Create profile"
        })
      })]
    })]
  });
}